/* Produktseite Runde 2/3 (Lenny, 2026-10-10)
   1) Groesse: Chip direkt unter dem Titel (kommt aus snippets/lv-title-soft.liquid; fehlt sie dort, wird sie hier aus der Beschreibung nachgeliefert). Zustand als eigene Karte UEBER den Details (aus der Beschreibung entnommen und dort entfernt)
   2) Desktop: Bildbreite an die Fensterhoehe anpassen
   3) Rabatt-Hinweis unter der Ueberschrift von "Complete the fit"
   4) Produkttitel: maximal zwei Zeilen (Schrift schrumpft schrittweise bis MIN_TITLE_PX, danach Kuerzung mit "...") */
(function () {
  // 1) Groesse + Zustand aus der Beschreibung. SHOW_CONDITION_SCORE = false blendet die Zustands-Karte komplett aus.
  var SHOW_CONDITION_SCORE = true;
  var de = (document.documentElement.lang || '').slice(0, 2) === 'de';
  var d = document.querySelector('.product__description');
  if (d && !document.querySelector('.lv-cond')) {
    var clean = function (el) { return (el.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); };
    var condEl = null, sizeEl = null, condText = '', sizeText = '';
    // Zeilenweise Erkennung (Marke/Größe/Zustand stehen oft in EINEM Absatz mit Zeilenumbrüchen). Marke und Größe stehen schon über dem Titel, Maße-Hinweis steht bei den Kacheln -> hier entfernen.
    var raw = (d.innerText || '').replace(/\u00a0/g, ' ');
    if (/(^|\n)\s*(Brand|Marke|Size|Gr(?:ö|oe)(?:ß|ss)e|Condition|Zustand)\s*:/i.test(raw) && !d.querySelector('ul, ol, table, a')) {
      var lines = raw.split('\n').map(function (x) { return x.trim(); });
      var keep = [], inMeas = false;
      lines.forEach(function (ln) {
        var mm;
        if ((mm = ln.match(/^(?:Brand|Marke)\s*:\s*(.*)$/i))) { return; }
        if ((mm = ln.match(/^(?:Size|Gr(?:ö|oe)(?:ß|ss)e)\s*:\s*(.*)$/i))) { if (!sizeText) sizeText = mm[1]; return; }
        if ((mm = ln.match(/^(?:Condition|Zustand)\s*:\s*(.*)$/i))) { if (!condText) condText = mm[1]; return; }
        if ((mm = ln.match(/^Details?\s*:\s*(.*)$/i))) { keep.push(mm[1]); inMeas = false; return; }
        if (/^(?:Measurements?|Ma(?:ß|ss)e)\b[^:]*:\s*$/i.test(ln)) { inMeas = true; return; }
        if (inMeas && /(see|siehe).*(pictures|photos|fotos|bilder)|^(?:see|siehe)\b/i.test(ln)) { return; }
        if (inMeas && ln) { keep.push('Measurements:'); inMeas = false; }
        keep.push(ln);
      });
      var paras = keep.join('\n').split(/\n{2,}/).map(function (x) { return x.trim(); }).filter(Boolean);
      d.textContent = '';
      paras.forEach(function (pt) { var pe = document.createElement('p'); pe.textContent = pt; d.appendChild(pe); });
      condEl = d; sizeEl = null;
    }
    var rowsEls = condEl ? [] : d.querySelectorAll('p, li');
    for (var i = 0; i < rowsEls.length; i++) {
      var el = rowsEls[i];
      if (el.querySelector('p, li')) continue;
      var tx = clean(el);
      var mc = tx.match(/^(?:Condition|Zustand)\s*:\s*(\S.*)$/i);
      if (!condEl && mc && tx.length < 160) { condEl = el; condText = mc[1]; continue; }
      var ms = tx.match(/^(?:Size|Gr(?:ö|oe)(?:ß|ss)e)\s*:\s*(\S.*)$/i);
      if (!sizeEl && ms && tx.length < 40) { sizeEl = el; sizeText = ms[1]; }
    }
    if (condEl || sizeEl) {
      if (condEl && condEl !== d) condEl.parentNode.removeChild(condEl);
      if (sizeEl) sizeEl.parentNode.removeChild(sizeEl);
      // Groesse: nur nachliefern, wenn der Titel keine Groesse enthielt (dann gibt es noch keinen Chip)
      var tt = document.querySelector('.product__title');
      if (sizeText && tt && !document.querySelector('.lv-spec')) {
        var chip = document.createElement('div');
        chip.className = 'lv-spec';
        var cs = document.createElement('small');
        cs.textContent = de ? 'Größe' : 'Size';
        var cb = document.createElement('b');
        cb.textContent = sizeText;
        chip.appendChild(cs);
        chip.appendChild(cb);
        var box = document.createElement('div');
        box.className = 'lv-specs lv-specs--title';
        box.style.margin = '0.2rem 0 1.4rem';
        box.appendChild(chip);
        tt.parentNode.insertBefore(box, tt.nextSibling);
      }
      // Zustand: nicht mehr neben der Groesse, sondern oben im Feld "Produktdetails" (Runde 6, Lenny 2026-10-12)
      if (condText && SHOW_CONDITION_SCORE) {
        var m = condText.match(/^(\d+(?:[.,]\d)?)\s*\/\s*10\s*(.*)$/);
        d.setAttribute('data-lv-cond', m ? m[1] + '/10' : condText);
        var note = m ? m[2].replace(/^[\s\-–:,;]+/, '').replace(/^\((.*)\)$/, '$1').trim() : '';
        if (note) d.setAttribute('data-lv-cond-note', note);
      }
    }
  }

  // 2) Desktop: Bildbreite an die Fensterhoehe anpassen
  function fitGallery() {
    var root = document.documentElement;
    var m = document.querySelector('.product__media');
    var wrap = document.querySelector('.product__media-wrapper');
    if (!m || !wrap || window.innerWidth < 990) { root.style.removeProperty('--lv-gal-w'); return; }
    var mt = (m.getAttribute('style') || '').match(/padding-top:\s*([\d.]+)%/);
    var ratio = mt ? parseFloat(mt[1]) / 100 : 0;
    if (!ratio) return;
    var hdr = (document.querySelector('sticky-header') || document.querySelector('.section-header') || { offsetHeight: 80 }).offsetHeight;
    var parentW = wrap.parentElement ? wrap.parentElement.getBoundingClientRect().width : 1200;
    var w = Math.floor((window.innerHeight - hdr - 20) / ratio);
    w = Math.max(380, Math.min(w, Math.floor(parentW * 0.56)));
    root.style.setProperty('--lv-gal-w', w + 'px');
  }
  fitGallery();
  window.addEventListener('load', fitGallery);
  window.addEventListener('resize', fitGallery);

  // 3) Rabatt-Hinweis unter "Complete the fit"
  var cf = document.querySelector('[id$="__featured_collection_wQCPbp"] .collection__title');
  if (cf && !cf.querySelector('.lv-cf-sub')) {
    var sub = document.createElement('p');
    sub.className = 'lv-cf-sub';
    sub.textContent = de ? 'Ab 3 Teilen 20 % sparen – wird im Warenkorb abgezogen.' : 'Take 3 pieces and save 20% – applied in your cart.';
    cf.appendChild(sub);
  }

  // 4) Produkttitel: hoechstens zwei Zeilen. Normal 22 px (Vorgabe aus lv-pdp.css); wird zu lang -> in 0,5-px-Schritten kleiner bis MIN_TITLE_PX; reicht das nicht -> nach zwei Zeilen mit "..." abschneiden.
  var MIN_TITLE_PX = 14;
  function fitTitle() {
    var h = document.querySelector('.product__title h1');
    if (!h) return;
    ['font-size', 'display', '-webkit-line-clamp', '-webkit-box-orient', 'overflow'].forEach(function (p) { h.style.removeProperty(p); });
    var cs = getComputedStyle(h);
    var size = parseFloat(cs.fontSize) || 22;
    var lines = function () {
      var lh = parseFloat(getComputedStyle(h).lineHeight) || size * 1.3;
      return Math.round(h.scrollHeight / lh);
    };
    while (lines() > 2 && size > MIN_TITLE_PX) {
      size -= 0.5;
      h.style.setProperty('font-size', size + 'px', 'important');
    }
    if (lines() > 2) {
      h.style.setProperty('display', '-webkit-box', 'important');
      h.style.setProperty('-webkit-box-orient', 'vertical', 'important');
      h.style.setProperty('-webkit-line-clamp', '2', 'important');
      h.style.setProperty('overflow', 'hidden', 'important');
      h.setAttribute('title', h.textContent.replace(/\s+/g, ' ').trim());
    }
  }
  var titleTimer;
  function fitTitleSoon() { clearTimeout(titleTimer); titleTimer = setTimeout(fitTitle, 120); }
  fitTitle();
  window.addEventListener('load', fitTitle);
  window.addEventListener('resize', fitTitleSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);
})();
